import { useEffect, useMemo } from 'react';
import { get } from 'lodash';
import moment from 'moment';
import { LANGUAGE, LOCALE } from '../adapters/constants';
import useUserInfo from './useUserInfo';
import 'moment/locale/fr-ca';

const useLocale = (): { locale: string; defaultLocale: string } => {
  const { userInfo } = useUserInfo();

  const userLocal = get(userInfo, 'iamUser.locale', LANGUAGE.ENGLISH) as string;

  const locale = useMemo(() => {
    switch (userLocal) {
      case LOCALE.FRENCH:
        return LANGUAGE.FRENCH;
      case LOCALE.ENGLISH:
      default:
        return LANGUAGE.ENGLISH;
    }
  }, [userLocal]);

  useEffect(() => {
    if (locale === LANGUAGE.FRENCH) moment.locale('fr-ca');
    else moment.locale('en-us');
  }, [locale]);

  return { locale, defaultLocale: LANGUAGE.ENGLISH };
};

export default useLocale;
